import Firebase from "firebase/app";
import "firebase/auth";
import "firebase/messaging";

import { FB_URL } from "./apiConfig";

const firebaseConfig = {
	apiKey: "AIzaSyD3H93e6rh_bpzc26VYt-_Y75OyThaX75s",
	authDomain: "centro-cei.firebaseapp.com",
	databaseURL: "https://centro-cei.firebaseio.com",
	projectId: "centro-cei",
	storageBucket: "centro-cei.appspot.com",
	messagingSenderId: "775416718209",
	appId: "1:775416718209:web:8e4f27fe554572d6"
};
// Initialize Firebase
Firebase.initializeApp(firebaseConfig);

export function sendTopics(arrPref) {
	//console.warn("Suscribiendo a ", arrPref);
	return new Promise((resolve, reject) => {
		fetch(FB_URL, {
			method: "POST",
			mode: "no-cors",
			headers: {
				"Content-Type": "application/json"
				/*Authorization: "Bearer AAA"*/
			},
			body: JSON.stringify(arrPref)
		})
			.then(response => {
				return response;
			})
			.then(() => {
				resolve();
				//console.log("Respuesta FB:", data);
			})
			.catch(err => {
				reject(err);
			});
	});
}

//A la escucha en focus app
if (Firebase.messaging.isSupported()) {
	var messaging = Firebase.messaging();

	Firebase.messaging().onMessage(payload => {
		//var noti = payload.notification;
		//consosle.log("payload", payload);

		//console.log("Message received. ", noti);
		navigator.serviceWorker.ready.then(resSW => {
			resSW.active.postMessage(payload);
		});
	});
}

export const provider = new Firebase.auth.GoogleAuthProvider();
export const auth = Firebase.auth();
export const fb_mss = Firebase.messaging;
export { messaging };
